import {FC, useMemo} from 'react'
import Highcharts from 'highcharts/es-modules/masters/highcharts.src'
import HighchartsReact from 'highcharts-react-official'
import {CGETradeVolume} from '../core/_models'
import {divergingColor} from './chartColors'

type CGETradeChartProps = {
  goodName: string
  volumes: CGETradeVolume[]
}

const CGETradeChart: FC<CGETradeChartProps> = ({goodName, volumes}) => {
  const options = useMemo(
    () => ({
      chart: {type: 'bar', height: 380, backgroundColor: 'transparent'},
      title: {text: ''},
      xAxis: {categories: volumes.map((v) => v.name), labels: {style: {fontSize: '0.8rem'}}},
      yAxis: {title: {text: `Export volume change (%) | ${goodName}`}},
      legend: {enabled: false},
      credits: {enabled: false},
      tooltip: {
        pointFormatter: function (this: any) {
          return `Export volume change: <b>${this.y}%</b>`
        },
      },
      plotOptions: {
        bar: {
          borderWidth: 0,
          dataLabels: {enabled: true, format: '{y}%'},
        },
      },
      series: [
        {
          name: 'Export volume change',
          data: volumes.map((v) => ({
            y: v.export_volume_pct,
            color: divergingColor(v.export_volume_pct),
          })),
        },
      ],
    }),
    [goodName, volumes]
  )

  return <HighchartsReact highcharts={Highcharts} options={options} />
}

export {CGETradeChart}
